// Schmucktext: Zeichen, die man sieht, die aber weder zum Namen noch zur
// sichtbaren Beschriftung eines Bedienelements gehoeren -- Tastenhinweise neben
// einer Beschriftung, die Initialen im Kontokreis.
//
// Als Textknoten zaehlte axe (ab 4.14, auch unter aria-hidden) sie zur
// sichtbaren Beschriftung, und WCAG 2.5.3 verlangte sie dann im Namen
// ("Konto von Maria" haette "MB Maria" enthalten muessen). Als erzeugter
// Inhalt mit leerem Alternativtext ("/ ''") stehen sie nur im Bild: Screenreader
// lesen nichts vor, der Name bleibt der sprechende.

import { makeStyles } from '@fluentui/react-components';

/** Das Attribut, aus dem der erzeugte Inhalt liest. */
export const SCHMUCK_ATTRIBUT = 'data-schmuck';

export const useSchmuckStyles = makeStyles({
  schmuck: {
    // Zuerst ohne Alternativtext: Browser ohne die Schreibweise "/ ''" (Firefox vor 128,
    // Safari vor 17.4) verwerfen die zweite Angabe und zeigen das Zeichen trotzdem; still
    // bleibt es dort ueber aria-hidden am Element.
    '::before': { content: [`attr(${SCHMUCK_ATTRIBUT})`, `attr(${SCHMUCK_ATTRIBUT}) / ""`] },
  },
});
